import React, { lazy, Suspense, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const Studio = lazy(() => import("../pages/Studio"));
const TemplateStudio = lazy(() => import("../pages/TemplateStudio"));

export const openStudioPopup = (which) => window.dispatchEvent(new CustomEvent("rosterly:open-studio", { detail: which }));

// Studio + Template Studio open as POP-UPS over the Stories page (no dedicated nav pages).
export function StudioPopupHost() {
    const [which, setWhich] = useState(null);
    useEffect(() => {
        const on = (e) => setWhich((cur) => (cur === e.detail ? null : e.detail));
        window.addEventListener("rosterly:open-studio", on);
        return () => window.removeEventListener("rosterly:open-studio", on);
    }, []);
    useEffect(() => {
        if (!which) return undefined;
        const k = (e) => { if (e.key === "Escape") setWhich(null); };
        window.addEventListener("keydown", k);
        return () => window.removeEventListener("keydown", k);
    }, [which]);
    if (!which) return null;
    return createPortal(
        <div className="fixed inset-0 z-[9000] bg-black/70 backdrop-blur-sm flex items-stretch justify-center p-2 sm:p-6" onMouseDown={(e) => { if (e.target === e.currentTarget) setWhich(null); }} data-testid="studio-popup">
            <div className="relative w-full max-w-[1500px] rounded-2xl border border-white/10 bg-[#0A0B10] shadow-2xl overflow-y-auto">
                <button type="button" onClick={() => setWhich(null)} data-testid="studio-popup-close" aria-label="Close"
                    className="sticky top-2 float-right mr-2 mt-2 z-10 h-9 w-9 rounded-full border border-white/15 bg-black/60 flex items-center justify-center text-white hover:bg-white/10">
                    <X className="h-4 w-4" />
                </button>
                <div className="p-3 sm:p-5" data-testid={`studio-popup-${which}`}>
                    <Suspense fallback={<div className="p-10 text-center text-white/50 text-sm">Loading…</div>}>
                        {which === "templates" ? <TemplateStudio /> : <Studio />}
                    </Suspense>
                </div>
            </div>
        </div>,
        document.body,
    );
}
